import React, { useState } from 'react';
import { Box, Flex, Text } from 'rebass/styled-components';
import { ProfilePicture, Tooltip } from '@getro/rombo';
import PropTypes from 'prop-types';
import { Mail } from 'lucide-react';

export const ContactOfWithEmail = ({ user, sx = {}, isSingle = false, type, width }) => {
  const [copiedEmail, setCopiedEmail] = useState(false);

  const handleCopyEmail = (event) => {
    event.stopPropagation();
    if (navigator && navigator.clipboard) {
      navigator.clipboard.writeText(user.email);
      setCopiedEmail(true);
    }
  };

  return (
    <Flex sx={{ gap: '8px', p: '8px 16px', justifyContent: 'space-between', alignItems: 'center', ...sx }}>
      <Flex sx={{ gap: '8px', alignItems: 'center' }}>
        <ProfilePicture
          sx={{
            boxShadow: isSingle ? '0px 0px 0px 2px #FFFFFF, 0px 0px 0px 2px #DEE4ED' : 'none',
            minWidth: width,
            minHeight: width,
          }}
          name={user.name}
          size={width}
          imageUrl={user.avatarUrl}
        />
        <Text
          sx={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            fontSize: '14px',
            color: 'text.main',
          }}
        >
          {user.name}
        </Text>
      </Flex>

      {type !== 'public' && user.email && typeof user.email === 'string' && (
        <Tooltip
          sx={{ color: 'neutral.0', outline: 'none' }}
          triggerProps={{
            sx: { outline: 'none' },
          }}
          position="right"
          content={
            <Text fontSize="12px" color="neutral.0">
              {copiedEmail ? 'Email copied!' : 'Copy email'}
            </Text>
          }
          trigger={
            <Box
              id="copy-email"
              sx={{ outline: 'none', minWidth: '16px', minHeight: '16px', maxHeight: '16px', cursor: 'pointer' }}
            >
              <Box as={Mail} size="16px" sx={{ color: 'text.main' }} onClick={handleCopyEmail} />
            </Box>
          }
        />
      )}
    </Flex>
  );
};

ContactOfWithEmail.propTypes = {
  user: PropTypes.object.isRequired,
  sx: PropTypes.object,
  isSingle: PropTypes.bool,
  type: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

ContactOfWithEmail.defaultProps = {
  sx: {},
  isSingle: false,
  type: 'default',
  width: '24px',
};
